import { createSlice } from '@reduxjs/toolkit';

import {
  AccountabilityState,
  SetAccountabilityTemplatePayload,
  SetLeaderboardPayload,
  SetTeamLeaderboardPayload
} from './accountability.types';

export const initialState: AccountabilityState = {
  accountabilityTemplate: undefined,
  leaderboard: undefined,
  teamLeaderboard: undefined
};

const AccountabilitySlice = createSlice({
  name: 'accountability',
  initialState,
  reducers: {
    setAccountabilityTemplate: (state, action: SetAccountabilityTemplatePayload) => {
      state.accountabilityTemplate = action.payload;
    },
    setLeaderboard: (state, action: SetLeaderboardPayload) => {
      state.leaderboard = action.payload;
    },
    setTeamLeaderboard: (state, action: SetTeamLeaderboardPayload) => {
      state.teamLeaderboard = action.payload;
    }
  }
});

export const { setAccountabilityTemplate, setLeaderboard, setTeamLeaderboard } = AccountabilitySlice.actions;

export default AccountabilitySlice.reducer;
